import { Box, Tooltip, IconButton, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import LinkIcon from '@mui/icons-material/Link'

interface TrackingCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const TrackingCell: FC<TrackingCellProps> = ({ params, densityStyles: _densityStyles }) => {
  const { trackingType, trackingUrl } = params.row

  const handleOpenLink = e => {
    e.stopPropagation()
    if (trackingUrl) {
      window.open(trackingUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        {trackingType && trackingUrl ? (
          <Box display="flex" alignItems="center">
            <Tooltip title={trackingUrl ? 'Open Tracking Link' : 'No Tracking URL'}>
              <span>
                <IconButton size="small" onClick={handleOpenLink} disabled={!trackingUrl} sx={{ p: 0.5 }}>
                  <LinkIcon fontSize="small" sx={{ color: 'rgb(78, 122, 243)' }} />
                </IconButton>
              </span>
            </Tooltip>
            <Typography variant="body2" sx={{ ml: 0.5 }}>
              {trackingType || '-'}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </>
  )
}

export default TrackingCell
